import QuizSimpleEditor from './QuizSimpleEditor';

export default QuizSimpleEditor;
